import Link from '@eliadmin/core/src/components/link';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

const pillLinkVariants = cva('inline-flex items-center rounded-full font-semibold', {
  variants: {
    variant: {
      primary:
        'bg-[#00a1e6] px-6 py-3.5 text-white transition-transform duration-200 hover:-translate-y-px',
      outline:
        'bg-transparent px-6 py-3.5 shadow-[inset_0_0_0_1.5px_currentColor] transition-transform duration-200 hover:-translate-y-px',
      dark: 'gap-2 bg-[#14181c] px-5 py-[11px] text-[.92rem] text-white transition-[transform,background-color] duration-200 hover:-translate-y-px hover:bg-[#0077c8]',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

type PillLinkProps = ComponentProps<typeof Link> & VariantProps<typeof pillLinkVariants>;

export function PillLink({ variant, className, prefetch = false, ...props }: PillLinkProps) {
  return (
    <Link prefetch={prefetch} className={cn(pillLinkVariants({ variant }), className)} {...props} />
  );
}
